<template>
  <div class="notiMess">
    <header class="flex-js-ac">
      <p>创客云商消息中心</p>
      <img src="/static/images/read.png" @click="readHandle" />
    </header>
    <div class="h"></div>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      class="my_scroller"
      ref="my_scroller"
    >
      <ul>
        <van-swipe-cell
          v-for="(item, index) of listData"
          :key="index"
          right-width="55"
          :before-close="deleteMessage"
          :itemid="item.id"
          :index="index"
        >
          <li class="listLi">
            <div class="titleBox">
              <b>{{ item.title }}</b>
              <span>
                {{ item.time.replace(/-/g, '/') }}&nbsp;
                <i v-if="item.ifread == 0"></i>
              </span>
            </div>
            <div class="contentBox" @click="listClick(item, index)">
              <p>
                {{ item.content.length > 35 ? item.content.substr(0, 35) + '...' : item.content }}
              </p>
              <img src="../../assets/images/jt2.png" />
            </div>
          </li>
          <template #right>
            <van-button square text="删除" type="danger" color="#FC0324" class="delete-button" />
          </template>
        </van-swipe-cell>
      </ul>
    </Scroller>
    <!--<p><span>————</span>&nbsp;&nbsp;客官，木有啦~&nbsp;&nbsp;<span>————</span></p>-->
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
import { SwipeCell } from 'vant'

Vue.use(SwipeCell)

export default {
  name: 'noticeMessage',
  data() {
    return {
      listData: [],
      clickIndex: null,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  components: {
    Scroller
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'personnoticemessage' })
    }
    // this.nowPage = 1
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.nowPage = 0
      })
    } else {
      next((vm) => {
        if (from.path == '/messagecenter') Object.assign(vm.$data, vm.$options.data())
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    //记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path == '/messagecenter') this.loading = true
    next()
  },
  methods: {
    getData(fn) {
      var url =
        this.$ajax.getPersonMessageList_URL +
        '?pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.listData = res.data.list
            that.refresh = false
          } else {
            that.listData = that.listData.concat(res.data.list)
          }
          that.loading = false
          if (res.data.list.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      var that = this
      that.getData()
      // this.editorClick()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    readHandle: function () {
      var url = this.$ajax.readUserMsg_URL
      var paramsData = {
        type: 1
      }
      this.$customRequestAjax.post(url, paramsData).then((res) => {
        if (res.data.code == 200) {
          this.listData.map((item) => {
            item.ifread = 1
          })
          this.$toast('已全部标记为已读')
        }
      })
    },
    deleteMessage: function ({ position, instance }) {
      if (position == 'right') {
        var itemid = instance.$el.attributes.itemid.nodeValue,
          index = instance.$el.attributes.index.nodeValue,
          url = this.$ajax.deleteMessageById_URL,
          paramsData = {
            type: 1,
            id: itemid
          }
        this.$customRequestAjax.post(url, paramsData).then((res) => {
          if (res.data.code == 200) {
            instance.close()
            this.listData.splice(index, 1)
            this.$toast('删除成功')
          }
        })
      }
    },
    listClick(items, idx) {
      // if (this.clickIndex != idx && this.clickIndex != null) {
      var url = this.$ajax.updateReadStatus_URL
      var data = {
        msgid: items.id,
        msgtype: 1
      }
      if (items.ifread == 0) {
        this.$customRequestAjax.post(url, data).then((res) => {
          if (res.data.code === 200) {
            items.ifread = 1
          }
        })
      }
      //   this.clickIndex = idx
      // }
      if (items.urltype == 1) {
        // 售后处理
        this.$router.push({
          path: '/afterdetails',
          query: {
            afterid: items.urlid
          }
        })
      } else if (items.urltype == 2) {
        // 积分明细
        this.$router.push('/integraldetails')
      } else if (items.urltype == 3) {
        // 订单详情
        this.$router.push({
          path: '/orderdetails',
          query: {
            id: items.urlid
          }
        })
      } else if (items.urltype == 4) {
        // 现金券列表
        this.$router.push('/cashcoupon')
      } else if (items.urltype == 5) {
        // 评价详情
        this.$router.push({
          path: '/commentDetail',
          query: {
            commentid: items.urlid
          }
        })
      } else if (items.urltype == 6) {
        // 商品详情
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: items.urlid
          }
        })
      } else if (items.urltype == 14) {
        // 我的
        this.$router.push({
          path: '/percen'
        })
      } else if (items.urltype == 16) {
        // 新品试用活动开始通知
        this.$router.push({
          path: '/newproductdetail',
          query: {
            id: items.urlid
          }
        })
      } else if (items.urltype == 20) {
        // 新品试用中奖
        this.$router.push({
          path: '/applyrecord'
        })
      } else if (items.urltype == 25) {
        // 首页
        this.$router.push({
          path: '/'
        })
      } else {
        if (items.url) {
          this.$dialog
            .confirm({
              title: items.title,
              message: items.content,
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '确定',
              cancelButtonText: '关闭',
              closeOnPopstate: true
            })
            .then(() => {
              // on confirm
              if (items.url) window.location.href = items.url
            })
        } else {
          this.$dialog({
            title: items.title,
            message: items.content,
            className: 'percen_button_alert',
            confirmButtonText: '确定'
          }).then(() => {
            // on confirm
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
header {
  height: 0.38rem;
  background: #fff;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding: 0 0.13rem 0 0.11rem;
  z-index: 1;
  p {
    font-size: 0.13rem;
    color: #3f3f3f;
  }
  img {
    width: 0.17rem;
    height: 0.17rem;
  }
}
.h {
  height: 0.38rem;
}
.delete-button {
  height: 100%;
  width: 55px;
  display: block;
  border-radius: 0 0.04rem 0.04rem 0;
}
.notiMess {
  > p {
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    text-align: center;
    padding: 0.3rem 0 0.33rem;
    span {
      color: rgba(221, 221, 221, 1);
    }
  }
  ul {
    margin: 0 0.11rem 0 0;
  }
  .listLi {
    /*height: 0.91rem;*/
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    -moz-flex-direction: column;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    -moz-justify-content: space-between;
    padding: 0.11rem 0.14rem 0.14rem 0.11rem;
    background: #fff;
    margin: 0.1rem 0 0 0.11rem;
    border-radius: 0.04rem;
    &:last-of-type {
      margin-bottom: 0.1rem;
    }
    .titleBox {
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      margin-bottom: 0.09rem;
      b {
        color: #222222;
        font-size: 0.15rem;
        display: block;
        font-weight: 600;
        flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        -o-flex: 1;
        overflow: hidden;
        /* visibility: collapse; */
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        color: #999999;
        font-size: 0.11rem;
        display: flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        -moz-align-items: center;
        i {
          display: block;
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          background: #fc0324;
        }
      }
    }
    .contentBox {
      height: 0.36rem;
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      p {
        color: #444444;
        font-size: 0.13rem;
        font-weight: 400;
        display: block;
        margin-right: 0.16rem;
      }
      img {
        width: 0.06rem;
        height: 0.11rem;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message/personNoticeMessage.vue